import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: BusinessCreditCheckState = {
}

const getters: GetterTree<BusinessCreditCheckState, RootState> = {
}

const actions: ActionTree<BusinessCreditCheckState, RootState> = {
  fetchList(context, options) {
    return http.v1.bcc.fetchList(options).then(({ data }) => {
      const payload = data
      const items = payload.data.data
      return {
        items,
        total: payload.data.total,
      }
    })
  },
  approve(context, {item}) {
    return http.v1.bcc.approve(item.object_id, item)
  },
  reject(context, {item}) {
    return http.v1.bcc.reject(item.object_id, item)
  },
  report(context, oid) {
    return http.v1.bcc.report(oid)
  },
}

const mutations: MutationTree<BusinessCreditCheckState> = {
}

const business: Module<BusinessCreditCheckState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default business